<template>
  <div>
      <div class="title_cover">
        <h3></h3>
      </div>
        <timer v-if="data_api.use_timer==1"/>
      <div class="form-page">
        
        <questions :form="form" :currentPage="'*'" :totalPage="0" :isTrivia="isTrivia" :percentage="percentage||null" />

      </div>
    
  </div>
</template>

<script>
const Questions = () => import(/* webpackChunkName: "questions" */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ /* webpackPreload: true */ './Questions.vue');
const Timer = () => import(/* webpackChunkName: "timer" */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ /* webpackPreload: true */ './Timer/Main.vue');

export default {
  components: { Questions,Timer },
  name: "Vertical",
  props:['form', 'isTrivia', 'proccessMain', 'percentage'],
  data() {
    return {
      data_api: this.$store.state.data.get,
    }
  },
  mounted()
  {
      this.viewTracker('question');
      this.$parent.$parent.$parent.updateHead();
  },
  methods:{
    
    next()
    {
      //Send Tracker
      this.sendtoCDP()
      this.sendExternalTracker()
      
      //submit
      if( this.proccessMain )
      {
        this.$parent.processMain()
      }
      else this.$parent.$parent.submit();

      //re validate answer
      if(Object.keys(this.$store.state.data.post.answer).length == this.form.length)
      {
        this.$store.commit('set_isvalid_answer', true);
      }
    }

  }
}
</script>